
import React from 'react'
import { connect } from "react-redux"
import ReactDOM from 'react-dom'

import { adminCreateTherapyCategory, adminDeleteTherapyCategory } from "../../actions/admin"
import { setTitle, fetchTherapyCategories } from "../../actions/index";

//import styles
import './styles/AdminTherapyAreas.scss';

import closeImage from '../../images/icons/close_black.svg';

import AdminTherapyCategory from './AdminTherapyCategory'

@connect(store => {
  return {
	therapy_categories: store.therapy_categories,
	practice_types: store.practice_types,
    User: store.User.User,
    app: store.app
  };
})
class AdminTherapyCategories extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openNewItem: false,
      newItem: {
        name: "",
        description: "",
        practice_type: ""
      },
      chosenPracticeType: ""
    };
    this.props.dispatch(setTitle("Admin: Therapy Categories"));
    this.handleNewItemChange = this.handleNewItemChange.bind(this);
    this.handleNewItemSubmit = this.handleNewItemSubmit.bind(this);
    this.toggleNewItem = this.toggleNewItem.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleChange = this.handleChange.bind(this);

  }

  componentDidMount(){
    // this.filterPracticeType();
    this.props.dispatch(fetchTherapyCategories())
    this.setState({
      chosenPracticeType: this.props.practice_types[0]._id
    })
    this.setState({
      newItem: {
        name: "",
        description: "",
        practice_type: this.state.chosenPracticeType
      }      
    });
  }

  handleDelete(id) {
    if (confirm("Really delete this Therapy Category?")) {
      this.props.dispatch(adminDeleteTherapyCategory(id));
    }
  }

  handleNewItemChange(e, field) {
    let newItem = this.state.newItem;
    newItem[field] = e.target.value;
    this.setState({ newItem: newItem });
  }

  handleNewItemSubmit(e) {
    e.preventDefault();
    if (this.state.newItem.name !== "") {
      this.props.dispatch(adminCreateTherapyCategory(this.state.newItem));
    }
    this.setState({
      newItem: {
        name: "",
        description: "",
        practice_type: ""
      }
    });
    this.toggleNewItem();
  }

  handleChange(event) {
    this.setState({ chosenPracticeType: event.target.value });
    this.setState({
      newItem: {
        name: "",
        description: "",
        practice_type: event.target.value
      }
    });
  }

  toggleNewItem() {
    this.setState({ openNewItem: !this.state.openNewItem });

    // slide page down too
    let page = ReactDOM.findDOMNode(this.refs.page);
    let addNewItem = ReactDOM.findDOMNode(this.refs.addNewItem);
    let transform = this.state.openNewItem ? 0 : addNewItem.offsetHeight;
    page.style.transition = "0.34s transform ease-out";
    page.style.transform = `translateY(${transform}px)`;
  }

  render() {
    return (
      <main className="main adminTherapyCatogories">
        <div
          ref="addNewItem"
          className={
            this.state.openNewItem
              ? "addItem--wrapper open"
              : "addItem--wrapper"
          }
        >
          <form onSubmit={this.handleNewItemSubmit}>
            <div className="selectLabel">HEALTHCARE PROFESSION:</div>
            <select
              className="md-input md-title professionSelect"
              value={this.state.newItem.practice_type}
              onChange={e => this.handleNewItemChange(e, "practice_type")}
            >
              {Object.values(this.props.practice_types).map(type => (
                <option key={type.id} value={type.id}>
                  {type.practice_type}
                </option>
              ))}
            </select>
            <input
              className="md-input md-title"
              onChange={e => this.handleNewItemChange(e, "name")}
              value={this.state.newItem.name}
              type="text"
              placeholder="Therapy category title"
              contentEditable="true"
            />
            <br />
            <br />
            <textarea
              className="md-input multiple"
              value={this.state.newItem.description}
              placeholder="Therapy category description"
              onChange={e => this.handleNewItemChange(e, "description")}
            />
            <p>
              <br />
              <button
                className="md-button md-raised md-primary"
                onClick={this.handleNewItemSubmit}
              >
                Create
              </button>
            </p>
          </form>
          <a
            href="#"
            onClick={this.toggleNewItem}
            className="top-draw-handle md-button-fab"
          >
            <img
              alt="close"
              className={
                "open-close " + (this.state.openNewItem ? "close" : "")
              }
              src={closeImage}
            />
          </a>
        </div>
        <div ref="page" className="height100 therpayCatagories">
          <div className="select my1 p1">
            Profession:
            <select
              value={this.state.chosenPracticeType}
              onChange={this.handleChange}
            >
              {Object.values(this.props.practice_types).map(type => (
                <option key={type.id} value={type.id}>
                  {type.practice_type}
                </option>
              ))}
            </select>
          </div>
          <div>
            <ul className="md-list wide mb8">
              {Object.values(this.props.therapy_categories)
                .filter(
                  cat => cat.practice_type === this.state.chosenPracticeType
                )
                .map(category => (
                  <AdminTherapyCategory
                    handleDelete={this.handleDelete}
                    category={category}
                    key={category._id}
                    clickDelete={this.handleDelete}
                  ></AdminTherapyCategory>
                ))}
            </ul>
          </div>
        </div>
      </main>
    );
  }
}

export default AdminTherapyCategories;



// WEBPACK FOOTER //
// ./src/components/admin/AdminTherapyCategories.jsx